export const dayRangeHeight = 68;

export const rangeStep = 15;

export const minuteHeight = dayRangeHeight / rangeStep;

export const oneHundredAndFiftyMinutes = 150;
